export type RpiCurrentStream = {
  deviceId: string
  flvUrl: string
  streamId: string
  url: string
  localRtcUrl: string
  remoteRtcUrl: string
}

export type RpiDevice = {
  id: string
  name: string
  use: 'audio' | 'video'
  resolution?: string[]
}

export type RpiHealthcheck = {
  AllSaved: boolean
  PresentDevices: Array<{
    device: RpiDevice
    stream?: boolean
  }>
  Internet: boolean
  Medconnect: boolean
  Ossrs: boolean
}

/**
 * Stream Info
 * Need to pass Stream ID in order to start a stream
 */
export type RpiStreamInfo = {
  id: string
  available: boolean
}

/**
 * Type of actions available to user
 * This list is also used on both server so make sure its the same everywhere
 */
export enum RpiRoutes {
  DEVICES = '/device',
  DEVICES_UPDATE = '/device/update',
  DEVICES_SAVE = '/device/save',
  ALIVE = '/alive',
  STREAMS = '/streams',
  STREAM_START = '/streams/start',
  STREAM_STOP = '/streams/stop',
  MSV = '/msv',
  TEST = '/healthcheck',
  RECORD = '/record'
}


/**
 * Interface in order to add verbose to cmmunication over sockets
 */
export type RpiActionParams = {
  room: string
  route: string
  arg?: any
}


/**
 * Interface in order to add verbose to data received by sockets
 */
export type RpiData =
  | { route: RpiRoutes.DEVICES | RpiRoutes.DEVICES_SAVE | RpiRoutes.DEVICES_UPDATE, data: RpiDevice[] }
  | { route: RpiRoutes.MSV, data: any }
  | { route: RpiRoutes.STREAMS, data: RpiStreamInfo[] }
  | { route: RpiRoutes.STREAM_START, data: RpiCurrentStream }
  | { route: RpiRoutes.STREAM_STOP, data: { stream: RpiStreamInfo, device: RpiDevice } }
  | { route: RpiRoutes.TEST, data: RpiHealthcheck }

export type RpiRecordParams = {
  duration: number
  url: string
  upload: {
    bucket: string
    content_type: string
    filename: string
    region: string
  }
}